import {
  deleteCouponApi,
  generateCouponApi,
  getAllCouponApi,
  getSingleCouponApi,
  updateCouponApi,
} from "../api/CouponsApi";
import {
  getAllOrdersApi,
  getAllSellerOrdersApi,
  updateOrderStatusApi,
  shipOrderApi,
  printManifestOrderApi,
  printInvoiceOrderApi,
  printLabelOrderApi,
  magicImageUrlApi,
  videosMaPApi,
  getMagicImageUrlApi,
} from "../api/OrderApi";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  orderResponse: {},
  orders: [],
  encryptedUrls: [],
  imagemapurls: [],
  singleimagemapurls: [],
  //   coupon: {},
  //   editCoupon: {
  //     isEdit: false,
  //     body: {},
  //   },
  keyword: "",
  sortdir: "",
  sortby: "",
  statusId: "",
  loading: false,
  successful: false,
  uploading: false,
  shipLoading: false,
  manifestLoading: false,
  invoiceLoading: false,
  labelLoading: false,
  shipOrder: {},
  ManifestOrder: {},
  InvoiceOrder: {},
  LabelOrder: {},
  magicimageurl: {},
  videomap: {},
};

export const getAllSellerOrders = createAsyncThunk(
  "order/getAllSellerOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllSellerOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateOrderStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateOrderStatusApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllOrders = createAsyncThunk(
  "order/getAllOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const shipOrder = createAsyncThunk(
  "order/shipOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shipOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const printManifestOrder = createAsyncThunk(
  "order/printManifestOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printManifestOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const printInvoiceOrder = createAsyncThunk(
  "order/printInvoiceOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printInvoiceOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const printLabelOrder = createAsyncThunk(
  "order/printLabelOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printLabelOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getMagicImageUrl = createAsyncThunk(
  "order/getMagicImageUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getMagicImageUrlApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const magicImageUrl = createAsyncThunk(
  "order/magicImageUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magicImageUrlApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const videosMaP = createAsyncThunk(
  "order/videosMaP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await videosMaPApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    addKeywordSearch: (state, action) => {
      state.keyword = action.payload;
    },
    addSortDir: (state, action) => {
      state.sortdir = action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby = action.payload;
    },
    addStatusId: (state, action) => {
      state.statusId = action.payload;
    },
    setEncryptedUrls: (state, action) => {
      state.encryptedUrls.push(action);
    },
    setImageMappedUrls: (state, action) => {
      const ind = state.imagemapurls.findIndex(
        (item) => item?.mapUploadID === action?.payload?.mapUploadID
      );

      if (ind !== -1) {
        console.log("New mappeed id", action.payload);
        state.imagemapurls[ind] = action.payload;
      } else {
        state.imagemapurls.push(action.payload);
      }
    },
    clearEncryptedUrls: (state, action) => {
      state.encryptedUrls = [];
    },
    clearImageMapUrls: (state, action) => {
      state.imagemapurls = [];
    },
  },
  extraReducers: (builder) => {
    // update order status
    builder.addCase(updateOrderStatus.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateOrderStatus.fulfilled, (state, action) => {
      state.orderResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateOrderStatus.rejected, (state) => {
      state.uploading = false;
    });

    // get all seller orders
    builder.addCase(getAllSellerOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSellerOrders.fulfilled, (state, action) => {
      state.orders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllSellerOrders.rejected, (state) => {
      state.loading = false;
    });

    // get all orders
    builder.addCase(getAllOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllOrders.fulfilled, (state, action) => {
      state.orders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllOrders.rejected, (state) => {
      state.loading = false;
    });

    // ship order
    builder.addCase(shipOrder.pending, (state) => {
      state.shipOrder = {};
      state.shipLoading = true;
    });
    builder.addCase(shipOrder.fulfilled, (state, action) => {
      state.shipOrder = action?.payload?.response;
      state.shipLoading = false;
    });
    builder.addCase(shipOrder.rejected, (state) => {
      state.shipOrder = {};
      state.shipLoading = false;
    });

    // print order
    builder.addCase(printManifestOrder.pending, (state) => {
      state.ManifestOrder = {};
      state.manifestLoading = true;
    });
    builder.addCase(printManifestOrder.fulfilled, (state, action) => {
      state.ManifestOrder = action?.payload?.response;
      state.manifestLoading = false;
    });
    builder.addCase(printManifestOrder.rejected, (state) => {
      state.ManifestOrder = {};
      state.manifestLoading = false;
    });

    // print invoice order
    builder.addCase(printInvoiceOrder.pending, (state) => {
      state.InvoiceOrder = {};
      state.invoiceLoading = true;
    });
    builder.addCase(printInvoiceOrder.fulfilled, (state, action) => {
      state.InvoiceOrder = action?.payload?.response;
      state.invoiceLoading = false;
    });
    builder.addCase(printInvoiceOrder.rejected, (state) => {
      state.InvoiceOrder = {};
      state.invoiceLoading = false;
    });

    // print label order
    builder.addCase(printLabelOrder.pending, (state) => {
      state.LabelOrder = {};
      state.labelLoading = true;
    });
    builder.addCase(printLabelOrder.fulfilled, (state, action) => {
      state.LabelOrder = action?.payload?.response;
      state.labelLoading = false;
    });
    builder.addCase(printLabelOrder.rejected, (state) => {
      state.LabelOrder = {};
      state.labelLoading = false;
    });

    // get magic url
    builder.addCase(magicImageUrl.pending, (state) => {
      state.magicimageurl = {};
      state.uploading = true;
    });
    builder.addCase(magicImageUrl.fulfilled, (state, action) => {
      state.magicimageurl = action?.payload?.response;
      state.uploading = true;
    });
    builder.addCase(magicImageUrl.rejected, (state) => {
      state.magicimageurl = {};
      state.uploading = false;
    });

    // get magic url
    builder.addCase(videosMaP.pending, (state) => {
      state.videomap = {};
      state.uploading = true;
    });
    builder.addCase(videosMaP.fulfilled, (state, action) => {
      state.videomap = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(videosMaP.rejected, (state) => {
      state.videomap = {};
      state.uploading = false;
    });

    // get single magic url
    builder.addCase(getMagicImageUrl.pending, (state) => {
      state.imagemapurls = [];
      state.loading = true;
    });
    builder.addCase(getMagicImageUrl.fulfilled, (state, action) => {
      // state.imagemapurls = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getMagicImageUrl.rejected, (state) => {
      state.imagemapurls = [];
      state.loading = false;
    });
  },
});

export const {
  addKeywordSearch,
  addSortBy,
  addSortDir,
  addStatusId,
  setEncryptedUrls,
  clearEncryptedUrls,
  setImageMappedUrls,
  clearImageMapUrls,
} = orderSlice.actions;
export default orderSlice.reducer;
